module.exports = __webpack_public_path__ + "static/media/kitchen_with_clipboard.220fc752.png";